var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-rate"},_vm._l((_vm.max),function(index){return _c('i',{key:index,staticClass:"iconfont",class:[_vm.icon, index <= _vm.rateLevel ? 'on' : 'off',index <= _vm.rateLevel ? 'onColor' : 'voidColor'],style:({'font-size': _vm.iconSize})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }